import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Crisis Banner */}
      <div className="bg-red-600 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-8 text-center">
            <div className="flex items-center space-x-2">
              <Phone className="w-5 h-5" />
              <span className="font-semibold">In Crisis? Call Now:</span>
            </div>
            <a href="tel:988" className="hover:underline font-bold text-xl">
              988 - Suicide & Crisis Lifeline
            </a>
            <a href="tel:1-800-662-4357" className="hover:underline font-bold text-xl">
              1-800-662-HELP
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold text-teal-400 mb-4">
              Two Sandwiches & A Nap
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              A place for hope, recovery, and healing. Remember: take care of yourself, 
              be kind to yourself, and take it one day at a time.
            </p>
            <div className="flex items-center space-x-2 text-gray-300 mb-3">
              <Mail className="w-5 h-5" />
              <a
                href="mailto:twosandwichesandanap@hotmail.com"
                className="hover:text-teal-400 transition-colors duration-200"
              >
                twosandwichesandanap@hotmail.com
              </a>
            </div>
            <a
              href="https://www.facebook.com/twosandwichesandanap"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-300 hover:text-teal-400 transition-colors duration-200"
            >
              <Facebook className="w-5 h-5" />
              <span>Follow us on Facebook</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Get Help Now
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  The Book
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-teal-400 transition-colors duration-200">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Important Resources */}
          <div>
            <h4 className="font-semibold text-white mb-4">24/7 Support</h4>
            <ul className="space-y-3 text-gray-300">
              <li>
                <a href="https://www.aa.org" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors duration-200">
                  Alcoholics Anonymous
                </a>
              </li>
              <li>
                <a href="https://www.na.org" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors duration-200">
                  Narcotics Anonymous
                </a>
              </li>
              <li>
                <a href="https://al-anon.org" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors duration-200">
                  Al-Anon (For Families)
                </a>
              </li>
              <li className="pt-2">
                <div className="font-semibold text-white">Text HOME to 741741</div>
                <div className="text-sm">Crisis Text Line</div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Two Sandwiches and a Nap. Recovery is possible.
            </p>
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-current" />
              <span>for those seeking hope</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
